import React from "react";
import { getMaturaCurriculumRule } from "../matura/maturaCurriculumScope";
import "./MaturaCurriculumNotice.css";
export default function MaturaCurriculumNotice({ task, sheetId, taskNo, rule, compact = false }) {
 const entry=rule || getMaturaCurriculumRule(task,{sheetId,taskNo});
 if(!entry) return null;
 return <aside className="matura-curriculum-notice" aria-label="Zakres wymagań zadania">
  <strong>{entry.badgeText || "Archiwalne · poza aktualnym zakresem podstawowym"}</strong>
  <details open={!compact}><summary>Dlaczego to zadanie jest w starszych maturach?</summary>
   <p>{entry.explanation}</p>
   <small>Zmiana od matury {entry.outsideFromExamYear}. Oryginalny arkusz zachowuje treść i punktację z roku egzaminu.</small>
   <details><summary>Źródła wymagań</summary><ul>{entry.sources.map(source=><li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer">{source.title}</a></li>)}</ul></details>
  </details>
 </aside>;
}
